import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../constants/qa'
import { LOCAL_STORAGE_NEWSBOARD_POST_FILE_DELETE_CONFIRMATION_DISABLED_KEY } from '../../../constants/storage'
import { setStorageItem } from '../../../utils/storage'
import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { ConfirmationModal } from '../../Confirmation'

import * as styles from './NewsboardPostFileDeleteConfirmationModal.module.css'

function NewsboardPostFileDeleteConfirmationModal({ onCancel, onSubmit }) {
  const { t } = useTranslation()

  const [isShowAgainDisabled, setShowAgainDisabled] = useState(false)

  async function handleSubmit() {
    if (isShowAgainDisabled) {
      setStorageItem(
        LOCAL_STORAGE_NEWSBOARD_POST_FILE_DELETE_CONFIRMATION_DISABLED_KEY,
        isShowAgainDisabled
      )
    }

    return onSubmit()
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('Modal.DeleteBtnKey'),
      }}
      description={t('Newsboard.PostFileDeleteConfirmationTextKey')}
      qaName={QA_NAME_CONFIRMATION}
      onCancel={onCancel}
      onSubmit={handleSubmit}
    >
      <Checkbox
        checked={isShowAgainDisabled}
        className={styles.checkbox}
        label={t('Newsboard.PostFileDeleteConfirmationCheckboxLabelKey')}
        labelClassName={styles.checkboxLabel}
        labelTitleClassName={styles.checkboxLabelTitle}
        size={CHECKBOX_SIZE.small}
        onChange={setShowAgainDisabled}
      />
    </ConfirmationModal>
  )
}

export default NewsboardPostFileDeleteConfirmationModal
